<template>
    <el-dialog
            title="选择分类"
            :visible="true"
            width="25%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="120px" :inline="true" class="mt20">

            <el-form-item label="一级分类:">
                <el-select v-model="form.value" placeholder="请选择" @change="selectLevelOne">
                    <el-option
                            v-for="item in options"
                            :key="item.key"
                            :label="item.label"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二级分类:">
                <el-select v-model="form.value1" placeholder="请选择" @change="selectLevelTwo">
                    <el-option
                            v-for="item in options"
                            :key="item.key"
                            :label="item.label"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="save()">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "cate-dialog",
        data() {
            return {
                options: [{
                    id: '1',
                    key: '家电',
                    label: '家电'
                }, {
                    id: '2',
                    key: '电视机',
                    label: '电视机'
                }, {
                    id: '3',
                    key: '冰箱',
                    label: '冰箱'
                }],
                form: {
                    value: '',
                    value1: '',
                    label1: '',
                    label2: '',
                },

            }
        },
        methods: {
            save() {
                this.$emit('pushData',this.form);
                this.$emit('handleClose');
            },
            selectLevelOne(val) {
                let obj = {};
                obj = this.options.find((item) => {
                    return item.id === val;
                });
                this.form.label1 = obj.label;

            },
            selectLevelTwo(val) {
                let obj = {};
                obj = this.options.find((item) => {
                    return item.id === val;
                });
                this.form.label2 = obj.label;
            },
            handleClose() {
                this.$emit('handleClose');
            }
        },
        created() {
        },
    }
</script>

<style lang="scss" scoped>

</style>